// extracted by mini-css-extract-plugin
export default {"cell":"style_cell__t23MP","cellText":"style_cellText__egUAJ","eventContent":"style_eventContent__rKk1X"};